import { Injectable } from '@angular/core';

import { storedSignal } from '../shared';

const options = {
  sidebarOpen: 'lcm:cfg:sidebarOpen',
  theme: 'lcm:cfg:theme',
};

@Injectable({ providedIn: 'root' })
export class Settings {
  sidebarOpen = storedSignal(options.sidebarOpen, true);

  theme = storedSignal(options.theme, 'dark');
}
